export const executionModeName = {
  Automatic: 'Automatic',
  RPF: 'RPF',
};

export const subStatusName = {
  NotPingable: 'Not pingable',
  MachineConnectorOff: 'Machine connector off',
  Offline: 'Offline',
  ConnectionFailed: 'Connection Failed',
  Canceled: 'Canceled',
  Running: 'Running',
  ConnectorOff: 'Connector off',
  ConnectionOff: 'Connection Switched Off',
  NoConnector: 'No connector',
  Idle: 'Idle',
  Stopped: 'Stopped',
  Interrupted: 'Interrupted',
  Active: 'Active',
  Checking: 'Checking',
  Started: 'Started',
  ConnectorOffline: 'Connector offline',
  ConnectorOnline: 'Connector online',
  TryingToConnect: 'Trying to connect',
  NoNcFileSelected: 'No NC File selected',
  NotRunning: 'Not running',
};

export const subStatuses = {
  NotPingable: 'NotPingable',
  MachineConnectorOff: 'MachineConnectorOff',
  Offline: 'Offline',
  Running: 'Running',
  ConnectorOff: 'ConnectorOff',
  ConnectionOff: 'ConnectionOff',
  NoConnector: 'NoConnector',
  Idle: 'Idle',
  Stopped: 'Stopped',
  Interrupted: 'Interrupted',
  Active: 'Active',
  Checking: 'Checking',
  ConnectionFailed: 'ConnectionFailed',
};
